/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import axios from 'axios'

export const getters = {
	initalized: state => !!state.data,
	isLoading: state => state.isLoading,
	configs: state => {
		if (state.isLoading || !state.data) {
			return null
		}
		return state.data
	},
	eventBanners: state => {
		if (!state.data) {
			return []
		}
		return state.data.filter(config => config.key.toLowerCase() === 'eventbanner').map(config => config.data)
	},
}

export const mutations = {
	setData(state, payload) {
		state.data = payload
	},
	setLoadingPromise(state, promise) {
		state.loadingPromise = promise
	},
	setLoading(state, value) {
		state.isLoading = value
	},
	clearLoadingPromise(state) {
		state.loadingPromise = null
	},
}

export const actions = {
	fetchConfigs({ state, commit }) {
		// This data is not likely to change, no need to fetch once loaded in
		if (state.data) {
			return state.data
		}

		// To avoid double fetching
		if (state.loadingPromise) {
			return state.loadingPromise
		}

		commit('setLoading', true)
		const promise = new Promise((resolve, reject) => {
			axios
				.get('/v1/configs')
				.then(response => {
					commit('setData', response.data?.configs)
					resolve(response)
				})
				.catch(error => {
					console.error(error)
					reject(error)
				})
				.finally(() => {
					commit('setLoading', false)
				})
		})

		commit('setLoadingPromise', promise)
		return promise
	},
}
